import { ConfigPayload } from "./OpenIdConnectIntegration.types";
import { actionErrorNotifier } from 'core/utils/helpers'
import { actionCoreApi } from 'core/utils/api'
import HTTPUrlHelper from 'shared/helpers/HTTPUrlHelper'
import ActionsList from 'core/actions/Actions.list'
import { ActionType } from 'core/utils/interfaces'

export const updateIdpMetadata = (payload: ConfigPayload, federationProviderId: string): ActionType => actionErrorNotifier(
	actionCoreApi(
		ActionsList.CreateIdpMetadata,
		HTTPUrlHelper.createIdpMetadataAPI(federationProviderId),
		'PUT',
		payload )
	, true,
	{
		title: '',
		message: 'notifications.authConfig.updateOidc'
	}
)